import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { DamagedItemsListItem } from "../../inventory.types";
import { ApiRoutesInventory } from "./../../constants";

export const requestGetDamagedItems = async (
  params: GetListRequestParams
): Promise<GetListResponse<DamagedItemsListItem>> => {
  return await instance.get(ApiRoutesInventory.AllDamagedItems, { params });
};
